module.exports = __webpack_public_path__ + "media/stylesheets/images/main/star/star-ad3c11f1df12514f4dad899643ebc399.png";